import {
  SubTitle,
  ContentWrapper,
  SubTitleWrapper,
  Pagination,
} from './WithPagination.styles';
import { ArrowRight } from '@/icons/index';
import { useState, useEffect, cloneElement, ReactElement } from 'react';
import useViewport from '@/hooks/useViewport';

interface Props {
  title: string;
  children: ReactElement;
}

const WithPagination = ({ title, children }: Props) => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState<number>(0);
  const [lastPage, setLastPage] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const back = () => {
    setPage((page) => (page > 0 ? page - 1 : 0));
  };

  const forward = () => {
    setPage((page) => (page < lastPage ? page + 1 : lastPage));
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 660);
    setIsTablet(window.innerWidth > 660 && window.innerWidth <= 910);
    setIsDesktop(window.innerWidth > 910);
  };

  useViewport(handleResize);

  useEffect(() => {
    if (isMobile) {
      setPerPage(1);
    } else if (isTablet) {
      setPerPage(children.props.perPage - 1);
    } else if (isDesktop) {
      setPerPage(children.props.perPage);
    }
    setPage(0);
  }, [isMobile, isTablet, isDesktop, children.props.perPage]);

  return !!((isMobile || isTablet || isDesktop) && perPage) ? (
    <>
      <SubTitleWrapper>
        <SubTitle>{title}</SubTitle>
        <Pagination
          disabledBack={page === 0}
          disabledForward={page === lastPage}
        >
          <ArrowRight onClick={back} />
          <ArrowRight onClick={forward} />
        </Pagination>
      </SubTitleWrapper>
      <ContentWrapper perPage={perPage}>
        {cloneElement(children, {
          page,
          perPage,
          setLastPage,
        })}
      </ContentWrapper>
    </>
  ) : null;
};

export default WithPagination;
